module.exports = __webpack_public_path__ + "static/media/Ribbon.929087f0.svg";